export default __webpack_public_path__ + "static/media/sinal.241e9a63.png";